import { onMounted } from 'vue';
/**
 * Injects a <script> tag into the page. Sources can be external or internal relative paths. Use this function when you want to include a script without
 * importing and including it in the app bundle
 */
export const useStaticScript = (paths, isAsync = true, isDeferred = true) => {
    onMounted(() => {
        if (!paths)
            return;
        const body = document.getElementsByTagName('body')[0];
        if (!body)
            return;
        let scripts;
        if (!Array.isArray(paths)) {
            scripts = [paths];
        }
        else {
            scripts = paths;
        }
        scripts.forEach(script => {
            if (!script.endsWith('.js'))
                return;
            const scriptEl = document.createElement('script');
            scriptEl.async = isAsync;
            scriptEl.defer = isDeferred;
            scriptEl.src = script;
            body.appendChild(scriptEl);
        });
    });
};
